export enum CheckoutStep {
  CheckOrder = 'CheckOrder',
  BillingInformation = 'BillingInformation',
  PaymentMethod = 'PaymentMethod',
}
